import { db } from "@/config/firebaseConfig";

//compute pageviews in the database using transaction (multiple inputs at the same time)
const setPageView = async (uid) => {
    try {
        //get current day/month/year
        const today = new Date();
        const monthyear = today.getFullYear()+'-'+(today.getMonth()+1)
        const day = today.getDate();    
        //check if day is already on the database, if not upload in the database
        const ref = db.ref(`analytics/${uid}/pageview/${monthyear}/${day}`);
        //Set the pageview +1
        await ref.transaction((current_value) => {
        return (current_value || 0) + 1;
      });
    } catch (error) {
      console.log(error);
    }
  };

//compute linkclicks in the database using transaction (multiple inputs at the same time)
const setLinkClick = async (uid,linkid) => {
    try {
        //get current day/month/year
        const today = new Date();
        const monthyear = (today.getMonth()+1)+'-'+today.getFullYear();
        const day = today.getDate();    
        //check if day is already on the database, if not upload in the database
        const ref = db.ref(`analytics/${uid}/linkclick/${linkid}/${monthyear}/${day}`);
        //Set the pageview +1
        await ref.transaction((current_value) => {
        return (current_value || 0) + 1;
      });
    } catch (error) {
      console.log(error);
    }
  };

//delete linkclicks in the database when user delete card
const delLinkClickAnalytics = async (uid,linkid) => {
  try {   
      const ref = db.ref(`analytics/${uid}/linkclick/${linkid}`);
      ref.remove();
  } catch (error) {
    console.log(error);
  }
};

export { setPageView, setLinkClick, delLinkClickAnalytics };
